/* eslint-disable no-dupe-keys */
import React, { useRef, useEffect, useContext } from 'react';
import { Box } from '@material-ui/core';
import * as echarts from 'echarts';
import { ThemeContext } from 'styled-components';
// import { BrandContext } from '@/contexts/ContextProviders';
import { fmtThousand, fmtPercent } from '@/utils/comUtil';

export default ({ data = [], height }) => {
  const themeContext = useContext(ThemeContext);
  // const brandContext = useContext(BrandContext);
  // const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const barRef = useRef(null);

  useEffect(() => {
    const yData = data.map((item) => item.name);
    var myChart = echarts.init(barRef?.current);
    var option;
    // 超过8条，显示滚动条，判断是否显示滚动条
    // var showEchart = false;
    // const count = [...data];
    // if (count.length > 0) {
    //   if (count.length > 7) {
    //     //7也可以调整用来判断是否显示滚动条
    //     showEchart = true;
    //   } else {
    //     showEchart = false;
    //   }
    // }
    option = {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      color: ['#017AFF'],
      legend: {
        type: 'scroll',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
        formatter: function (p) {
          return `${p[0].name}</br>${fmtThousand(
            p[0].data.number,
          )}\n&nbsp;${fmtPercent(p[0].data.percent, 2)}`;
        },
      },
      grid: {
        show: false, //是否显示直角坐标系网格。[ default: false ]
        left: '150', //grid 组件离容器左侧的距离。
        right: '30px',
        // borderColor: '#c45455', //网格的边框颜色
        bottom: '1%', //,
        width: '65%',
      },
      xAxis: {
        type: 'value',
        position: 'top',
        min: 0,
        max: 1,
        splitNumber: 5,
        axisLine: {
          lineStyle: {
            type: 'solid',
            color: '#B0B0B0',
          },
        },
        axisLabel: {
          formatter: function (p) {
            return p * 100 + '%';
          },
        },
      },
      yAxis: {
        type: 'category',
        data: yData,
        color: '#B0B0B0',
        axisLine: {
          //轴线
          lineStyle: {
            //轴线样式
            type: 'solid',
            color: '#B0B0B0',
          },
        },
        splitLine: {
          //分割线
          lineStyle: {
            //分割线样式
            type: 'solid',
            color: '#B0B0B0',
          },
        },
        // axisLabel: {
        //   textStyle: {
        //     color: '#B0B0B0',
        //     // fontSize: 16,
        //   },
        // },
        axisLabel: {
          //坐标轴刻度标签的相关设置。
          width: 150,
        },

        axisTick: {
          show: false, //是否显示刻度线
        },
      },
      // dataZoom: [
      //   {
      //     start: 0, //默认为0
      //     end: 100, //默认为100
      //     type: 'slider',
      //     maxValueSpan: 14, //显示数据的条数(默认显示10个)
      //     show: showEchart, //是否展示
      //     yAxisIndex: [0],
      //     handleSize: 0, //滑动条的 左右2个滑动条的大小
      //     height: '80%', //组件高度
      //     width: '10px',
      //     // itemWidth: 20,
      //     // left: 600,
      //     right: 8,
      //     top: 55,
      //     fillerColor: '#7B7B7B', // 滚动条颜色
      //     borderColor: '#ECF5FF',
      //     backgroundColor: '#E0E0E0', //两边未选中的滑动条区域的颜色
      //     showDataShadow: false, //是否显示数据阴影 默认auto
      //     showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
      //     realtime: true, //是否实时更新
      //     filterMode: 'filter',
      //     yAxisIndex: [0, 1], //控制的y轴
      //   },
      //   //滑块的属性
      //   {
      //     type: 'inside',
      //     show: true,
      //     yAxisIndex: [0, 1],
      //     start: 1, //默认为1
      //     end: 7, //默认为100
      //     zoomOnMouseWheel: false, // 关闭滚轮缩放
      //   },
      // ],
      series: [
        {
          type: 'bar',
          data: data,
          // barWidth: 10,
          barGap: 30,
          barCategoryGap: '30%',
          barMinHeight: 10,
          label: {
            show: true,
            position: 'right',
            fontSize: '12px',
            formatter: function (p) {
              return `${fmtThousand(p.data.number)} 人 ${fmtPercent(
                p.data.percent,
                2,
              )}`;
            },
          },
        },
      ],
    };

    option && myChart.setOption(option);
    myChart.resize();
    window.addEventListener(
      'resize',
      function () {
        myChart.resize();
      },
      false,
    );
    return () => {
      window.removeEventListener('resize', function () {
        myChart.resize();
      });
    };
  }, [chartsFontSize.s03, data, fontFamily]);
  return <Box ref={barRef} sx={{ width: '100%', height: height }}></Box>;
};
